import React from 'react'

import useTranslation from '@/Hooks/UseTranslation'
import { MsProjectImportResult, MsProjectPreview } from '@/Services/MsProjectImportService'

type Props = {
  importing: boolean
  preview: MsProjectPreview | null
  result: MsProjectImportResult | null
}

const MsProjectImportStepThree = ({ importing, preview, result }: Props) => {
  const { t } = useTranslation()

  if (importing) return <div className="text-center py-2">{t('MS_PROJECT_IMPORTER:ImportingFile')}</div>
  if (!preview && !result) return null

  if (result?.deduplicated) {
    return (
      <section className="ms-project-importer-complete ms-project-importer-complete--dedup" role="status">
        <div className="ms-project-importer-complete-mark" aria-hidden="true">{'\u21BA'}</div>
        <h5>{t('MS_PROJECT_IMPORTER:DeduplicatedTitle')}</h5>
        <p>{t('MS_PROJECT_IMPORTER:DeduplicatedBody')}</p>
        <p className="text-muted">
          <strong>{result.project?.name || preview?.project.name}</strong>
          {' \u2014 '}
          <em>{t('MS_PROJECT_IMPORTER:DeduplicatedRecentNote')}</em>
        </p>
      </section>
    )
  }

  if (result) {
    return (
      <section className="ms-project-importer-complete" role="status">
        <div className="ms-project-importer-complete-mark" aria-hidden="true">{'\u2713'}</div>
        <h5>{t('MS_PROJECT_IMPORTER:ImportSuccess')}</h5>
        <p>{result.project?.name || preview?.project.name}</p>
      </section>
    )
  }

  if (!preview) return null

  return (
    <section className="ms-project-importer-confirmation">
      <h5>{t('MS_PROJECT_IMPORTER:CreationTitle')}</h5>
      <p>{t('MS_PROJECT_IMPORTER:CreationDescription')}</p>
      <dl className="ms-project-importer-confirmation-summary">
        <div><dt>{t('MS_PROJECT_IMPORTER:ProjectName')}</dt><dd>{preview.project.name}</dd></div>
        <div><dt>{t('MS_PROJECT_IMPORTER:FileName')}</dt><dd>{preview.summary.fileName}</dd></div>
        <div><dt>{t('MS_PROJECT_IMPORTER:Groups')}</dt><dd>{preview.summary.groupCount}</dd></div>
        <div><dt>{t('MS_PROJECT_IMPORTER:Items')}</dt><dd>{preview.summary.itemCount}</dd></div>
        <div><dt>{t('MS_PROJECT_IMPORTER:Works')}</dt><dd>{preview.summary.workCount}</dd></div>
        <div><dt>{t('MS_PROJECT_IMPORTER:Relations')}</dt><dd>{preview.summary.relationCount}</dd></div>
        <div><dt>{t('MS_PROJECT_IMPORTER:Restrictions')}</dt><dd>{preview.summary.restrictionCount}</dd></div>
        <div><dt>{t('MS_PROJECT_IMPORTER:Costs')}</dt><dd>{preview.summary.costCount}</dd></div>
      </dl>
    </section>
  )
}

export default MsProjectImportStepThree
